import {
  PORTAL_DETAILS,
  PORTAL_SELECT_CONTRACT,
  FETCH_MISSIONS,
  FETCH_PORTAL_USERS,
  PORTAL_SELECT_KEYWORKER,
  PORTAL_DESELECT_KEYWORKER,
  PORTAL_SELECT_PROVIDER,
  PORTAL_LIST_CONTRACTS,
  PORTAL_CASELOAD,
  PORTAL_CASELOAD_ENDDATE,
  PORTAL_ORGADMIN_CASELOAD,
  FETCH_INTERVENTIONS,
  EMPTY_CANDIDATES,
  EMPTY_CANDIDATES_SELECTION,
  PORTAL_DASHBOARD_CASELOAD,
  PORTAL_ORGADMIN_CASELOAD_GLOBAL,
  PORTAL_ORGADMIN_CASELOAD_ENDDATE,
  PORTAL_SUPPLY_DATA,
  PORTAL_SUPPLY_LOW,
  PORTAL_ADZUNA_CATEGORY,
  PORTAL_ADZUNA_HISTOGRAM_CATEGORY,
  PORTAL_ADZUNA_HISTORICAL_CATEGORY,
  PORTAL_ADZUNA_REGION_DATA,
  SET_RECENTLY_VIEWED,
  PORTAL_LOCATION_LIST,
  UPDATE_BULK_UPLOAD_PROGRESS,
  SET_BULK_EMAIL_TEMPLATE,
  SET_ROLES,
  SET_SKILLS,
  SET_DEPARTMENTS,
  SET_LOCATIONS,
  SET_DEMOGRAPHICS,
  SET_LINEMANAGERS,
  SET_UNVERIFIED,
  CUSTOMER_CHECK,
  SET_HELP_VIDEOS,
  PORTAL_SELECT_LINEMANAGER,
  PORTAL_DESELECT_LINEMANAGER,
  PORTAL_SELECT_DEPARTMENT,
  PORTAL_DESELECT_DEPARTMENT,
  SKILLS_CHART_DATA,
  ROLES_CHART_DATA,
  PEOPLE_CHART_DATA,
  PROJECT_CHART_DATA,
  SET_FLYOUT_LIST,
  SET_FLYOUT_CANDIDATE,
  FETCH_SKILL_TYPES
} from "./types";

import async from 'async';
import _ from "lodash";
import { fetchCandidates } from "./candidates_actions";
import moment from "moment";
import { get, post } from "./api"
import { ConsoleLogger, Cache } from "aws-amplify/utils";
import { getUrl, uploadData } from "aws-amplify/storage";
const logger = new ConsoleLogger("PORTAL.ACTIONS");

function mergeObjectsWithSum(obj, obj1){
  return _.mergeWith(obj, obj1, (objValue, srcValue, key) => {

    if (["Achievement Orientation","Practical Intelligence","Conscientiousness","Independence","Interpersonal Orientation","Adjustment","Social Influence","Artistic","Conventional","Enterprising","Investigative","Realistic","Social"].includes(key)) {
        let current = parseFloat(objValue);
        let merge   = parseFloat(srcValue);
        if (isNaN(current)|| current === 0) {current = 0; return merge};
        if (isNaN(merge) || merge === 0) {merge = 0; return current;}

        return (current + merge) / 2 + "";
      }

      if (_.isNumber(objValue) || _.isNumber(srcValue)) {
      
        let src = (_.isNumber(srcValue)) ? srcValue: 0;
        let obj = (_.isNumber(objValue)) ? objValue: 0;
  
        if (src === 0){
          return parseInt(src) + parseInt(obj);
        } else {
          return parseInt(obj) + parseInt(src);
        }
      };
    
  });
};

export function getRecentlyViewed() {
  return async function(dispatch) {
    let data = await get("/keyworker/recently_viewed");
    dispatch({type: SET_RECENTLY_VIEWED, data: data});
  }
}

export function getPortalDetails() {
  return async function(dispatch, getState) {
    logger.info("getPortalDetails(): ");
    const state = getState();
    try {
      let data = await get("/user");
      dispatch({ type: PORTAL_DETAILS, portaldetails: data });

      if (state.auth.role === "keyworker") {
        dispatch(fetchCandidates());
        dispatch(fetchInterventions());
        dispatch(getMissions());
        dispatch(getKeyworkerCaseload(state.auth.currentAuthUser.username));
      } else {
        if (state.auth.role === "hr-manager" || state.auth.role === "line-manager") {
          dispatch(fetchUnverifiedCounts());
        }
      if (state.auth.role !== "super-admin"){
        dispatch(checkCustomer());
      } 
      }
    } catch (e) {
      logger.error("getPortalDetails():", e);
    }
  };
}


export function checkCustomer() {
  return async function(dispatch, getState) {
    logger.info("checkCustomer(): ");
    try {
      let data = await post("/user/checkcustomer", {});
      if(data){
        dispatch({ type: CUSTOMER_CHECK, isCustomer: true });
      }
    } catch (e) {
      logger.error("checkCustomer():", e);
    }
  };
}

export function getBillingConsole() {
  return async function(dispatch, getState) {
    logger.info("getbillingconsole(): ");
    try {
      let data = await post("/user/getbillingconsole", {});
      if(data && data.success){
        return data.session
      }
    } catch (e) {
      logger.error("getbillingconsole():", e);
    }
  };
}

export async function getCreditTotals() {
    const data = await get("/orgadmin/credits/balance");
    return data;
}


export function fetchInterventions() {
  return async function(dispatch, getState) {
    logger.info("fetchInterventions(): ");
    try {
      const state = getState();

      let data;

      if (state.portaldetails.user.role === "keyworker") {
        data = await get(`/keyworker/${state.portaldetails.user.userID}/interventions/${state.portaldetails.selectedContract.contractID}`);
      } else {
        data = await get("/orgadmin/interventions");
      }

      dispatch({ type: FETCH_INTERVENTIONS, interventions: data.data });
    } catch (e) {
      console.log("ERROR: actions.fetchInterventions():", e);
    }
  };
}

export function defaultCandidateSelection() {
  return async function(dispatch, getState) {
    let state = getState();
    try {
      if (state.auth.role === "org-admin" || state.auth.role === "hr-manager") {
        dispatch({ type: EMPTY_CANDIDATES_SELECTION });
      }
    } catch (e) {}
  };
}


export function selectContractNoRequest(contract) {
  return async function(dispatch) {
    logger.info("selectContract(): ", contract);
    try {
      dispatch({ type: PORTAL_SELECT_CONTRACT, contract: contract });
      dispatch(fetchCandidates());

    } catch (e) {
      logger.error("selectContract():", e);
    }
  };
}


export function selectContract(contract) {
  return async function(dispatch, getState) {
    logger.info("selectContract(): ", contract);
    let state = getState();
    try {
      dispatch({ type: PORTAL_SELECT_CONTRACT, contract: contract });
      dispatch({ type: EMPTY_CANDIDATES, candidates: null });
      if(contract){
        if (state.auth.role === "keyworker") {
          dispatch(fetchCandidates());
          dispatch(fetchInterventions());
          dispatch(getMissions());
          dispatch(getKeyworkerCaseload(state.auth.currentAuthUser.username));
        }
        else if(state.auth.role === "hr-manager" || state.auth.role === "line-manager") {
          dispatch(fetchInterventions());
          dispatch(getMissions());
        }
      }
    } catch (e) {
      logger.error("selectContract():", e);
    }
  };
}

export function selectProvider(provider) {
  return async function(dispatch, getState) {
    logger.info("selectProvider(): ", provider);
    try {
      dispatch({ type: PORTAL_SELECT_PROVIDER, provider: provider });
      dispatch({ type: EMPTY_CANDIDATES, candidates: null });

    } catch (e) {
      logger.error("selectProvider():", e);
    }
  };
}

export function getMissions() {
  return async function(dispatch, getState) {
    const state = getState();
    logger.info(
      "getMissions(): ",
      state.portaldetails.selectedContract.contractID
    );

    try {
      const currentKeyWorkerId = state.portaldetails.currentKeyWorker
        ? state.portaldetails.currentKeyWorker
        : state.portaldetails.user.userID;

      let data = await get(`/keyworker/${currentKeyWorkerId}/missions/${state.portaldetails.selectedContract.contractID}`);
      dispatch({ type: FETCH_MISSIONS, missions: data.data });
    } catch (e) {
      logger.error("getMissions():", e);
    }
  };
}



export const resetKeyworker = keyworkerId => async dispatch => {
  await Cache.clear();
  dispatch({ type: PORTAL_DESELECT_KEYWORKER });
  dispatch({ type: EMPTY_CANDIDATES, candidates: null });
};


export const setKeyworkerNoRequest = keyworkerId => async dispatch => {
  if (keyworkerId) {
    await Cache.clear();
    dispatch({ type: PORTAL_SELECT_KEYWORKER, keyworker: keyworkerId });
  }
};


export const setKeyworker = keyworkerId => async dispatch => {
  if (keyworkerId) {
    await Cache.clear();
    dispatch({ type: PORTAL_SELECT_KEYWORKER, keyworker: keyworkerId });
    dispatch({ type: EMPTY_CANDIDATES, candidates: null });
    try {
      const {
        data: { contracts }
      } = await get(`/orgadmin/keyworker/${keyworkerId}`);

      dispatch({ type: PORTAL_LIST_CONTRACTS, contracts: contracts });
    } catch (e) {
      logger.error("selectKeyworker():", e);
    }
  }
};


export function setupImCandidateRecentyViewed(candidate) {
  return async function(dispatch, getState) {
    const { portalusers: { allProviders=[] }} = getState()
    const foundProvider = allProviders.find((item) => item.sort === candidate.internalMobilityProvider)
    if(foundProvider){
      await dispatch({ type: PORTAL_SELECT_PROVIDER, provider: foundProvider });
      await dispatch({ type: PORTAL_SELECT_LINEMANAGER, lineManager: candidate.internalMobilityLineManager });
      await dispatch({ type: PORTAL_SELECT_DEPARTMENT, department: candidate.internalMobilityDepartment });
      await dispatch(fetchLineManagers())
      await dispatch(fetchDepartments())
      await dispatch(fetchLocations())
      await dispatch(fetchRoles())
    }
  }
};


export function setLineManger(lineManagerID) {
  return async function(dispatch, getState) {
    // console.log("setLineManger + " + lineManagerID)
    const { portaldetails: { currentDepartment }} = getState()
    if (lineManagerID) {
      dispatch({ type: PORTAL_SELECT_LINEMANAGER, lineManager: lineManagerID });
      dispatch({ type: EMPTY_CANDIDATES, candidates: null });
    }
    else{
      dispatch({ type: PORTAL_DESELECT_LINEMANAGER });
      dispatch({ type: EMPTY_CANDIDATES, candidates: null });
    }
  }
};


export function setDepartment(departmentID) {
  return async function(dispatch, getState) {
    // console.log("setDepartment + " + departmentID)
    const { portaldetails: { currentLineManager }} = getState()
    if (departmentID) {
      dispatch({ type: PORTAL_SELECT_DEPARTMENT, department: departmentID });
      dispatch({ type: EMPTY_CANDIDATES, candidates: null });
    }
    else{
      dispatch({ type: PORTAL_DESELECT_DEPARTMENT });
      dispatch({ type: EMPTY_CANDIDATES, candidates: null });
    }
  }
}


export const setKeyworkers = keyworkerId => async dispatch => {

  
  if (keyworkerId && keyworkerId.length > 0) {
    await Cache.clear();

    dispatch({ type: PORTAL_SELECT_KEYWORKER, keyworker: keyworkerId[0].value});

    try {
      let promises = [];
      let data = [];
      _.each(keyworkerId, (key) =>{
        let promise = new Promise((success, failure) => {
          get(`/orgadmin/keyworker/${key.value}`).then((d) => {
            data.push(d);
            return success();
          });
        });
        promises.push(promise);
      });
      Promise.all(promises).then(() => {
        let combineObject = {};
        _.each(data, (index) => {
          _.mergeWith(combineObject, index);
        });
        
        dispatch({ type: PORTAL_LIST_CONTRACTS, contracts: combineObject.data.contracts });
      });
    } catch (e) {
      logger.error("selectKeyworker():", e);
    }
  }
};

export const getPortalUsers = () => async dispatch => {
  try {
    let data = await get(`/orgadmin/portalusers`);

    dispatch({
      type: FETCH_PORTAL_USERS,
      data: data
    });
  } catch (e) {
    logger.error("getPortalUsers():", e);
  }
};

export const getKeyworkerCaseloads = (keyworkerId, contractId) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();

    if (!contractId) {
      contractId = state.portaldetails.selectedContract.contractID;
    }
    logger.info("getKeyworkerCaseloads(): ", contractId);

    if (keyworkerId && contractId) {

      let data = [];
      let functions = [];
      _.each(keyworkerId, (key, index) =>{

        // let promise = new Promise((success, failure) => {
          // happening to fast getting same result
          functions.push((callback)=> {
            get(`/keyworker/${key.value}/caseload/${contractId}`).then((d) => {
              data.push(d);
              callback();
            });
          });
        // });
        // promises.push(promise);
      });

      async.series(functions).then(() => {
        
        let combineObject = {};
        
        _.each(data, (index)=> {
          // combineObject  = mergeObjectsWithSum(combineObject)
          combineObject  = mergeObjectsWithSum( combineObject, index);
        });
        // get the last updated at not a combined updatedAt
        _.each(data, (d) => {
          if (d.data && d.data.updatedAt ){
            combineObject.data.updatedAt = d.data.updatedAt;
          }
        });
        
        dispatch({
          type: PORTAL_CASELOAD,
          payload: Object.assign({}, { ...combineObject.data, contractId, keyworkerId })
        });
  
        dispatch({
          type: PORTAL_DASHBOARD_CASELOAD,
          caseload: combineObject.data
        });
      })
      
    }
  } catch (e) {
    logger.error("getKeyworkerCaseload():", e);
  }
};


export const getKeyworkerCaseload = (keyworkerId, contractId) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();

    if (!contractId) {
      contractId = state.portaldetails.selectedContract.contractID;
    }
    logger.info("getKeyworkerCaseload(): ", contractId);

    if (keyworkerId && contractId) {
      const { data } = await get(`/keyworker/${keyworkerId}/caseload/${contractId}`);

      let obj =  Object.assign({}, { ...data, contractId, keyworkerId });
      dispatch({
        type: PORTAL_CASELOAD,
        payload: obj
      });

      dispatch({
        type: PORTAL_DASHBOARD_CASELOAD,
        caseload: data
      });
    }
  } catch (e) {
    logger.error("getKeyworkerCaseload():", e);
  }
};

export const getKeyworkerCaseloadWithDate = (keyworkerId, contractId, dateUnix, isEndDate) => async (dispatch) => {
  try {
    if (keyworkerId && contractId) {

      let data = [];
      let promises = [];
      _.each(keyworkerId,  (key, index) =>{
        let promise = new Promise((success, failure) => {
            post(`/keyworker/caseload`, {
              keyworker: key.value,
              contract: contractId,
              targeDate: dateUnix        
            }).then((d) => {
              data.push(d);
              return success();
            });
          });
        promises.push(promise);
      });
      Promise.all(promises).then(() => {
        
        let combineObject = {};
        
        _.each(data, (index)=> {
          combineObject  = mergeObjectsWithSum( combineObject, index);
        });
        // get the last updated at not a combined updatedAt
        _.each(data, (d) => {
          if (d.data && d.data.updatedAt ){
            combineObject.data.updatedAt = d.data.updatedAt;
          }
        });

        if (isEndDate){
          dispatch({
            type: PORTAL_CASELOAD_ENDDATE,
            payload: Object.assign({}, { ...combineObject.data, contractId, keyworkerId })
          });
        }
        else{
          dispatch({
            type: PORTAL_CASELOAD,
            payload: Object.assign({}, { ...combineObject.data, contractId, keyworkerId })
          });
        }
      })
    }
  } catch (e) {
    logger.error("getKeyworkerCaseloadWithDate():", e);
  }
};

export const getOrgAdminCaseloadWithDate = (dateUnix) => async dispatch => {
  try {
    const { data: orgadminCaseload } = await post(`/orgadmin/caseload`, {
      startDate: dateUnix
    });
    if (orgadminCaseload){
      dispatch({
        type: PORTAL_ORGADMIN_CASELOAD,
        caseload: orgadminCaseload
      });
      dispatch({
        type: PORTAL_DASHBOARD_CASELOAD,
        caseload: orgadminCaseload
      });
    }
  } catch (e) {
    logger.error("getOrgAdminCaseload():", e);
  }
};

export const getGlobalCaseload = () => async dispatch => {
    logger.info("Get Global Details")
    try {
      let data = await get("/orgadmin/global/caseload");
      dispatch({
        type: PORTAL_ORGADMIN_CASELOAD_GLOBAL,
        data: data.data
      })
    } catch (e) {
     
    }
}

export const getOrgAdminCaseloadWithEndDate = (dateUnix) => async dispatch => {
  try {
    const { data: orgadminCaseload } = await post(`/orgadmin/caseload`, {
      startDate: dateUnix
    });
    if (orgadminCaseload){
      dispatch({
        type: PORTAL_ORGADMIN_CASELOAD_ENDDATE,
        caseload: orgadminCaseload
      });
    }
  } catch (e) {
    logger.error("getOrgAdminCaseload():", e);
  }
};

export const getSupply = () => async (dispatch, getState) => {
  try {
    const state = getState();

    const data = await post('/jobs/query/dashboard_jobs_analytics', {
      "target": "high level"
    });
    dispatch({
      type: PORTAL_SUPPLY_DATA,
      data: data
    });

    if (!state.locationList){
      const getUrlResult = await getUrl({
        path: ({identityId}) => `protected/vacancy_files/uk_locations_list.json`,
      });
      const townsUrl = getUrlResult.url.href;
      
      const tempObj = await (await fetch(townsUrl)).json()
      dispatch({
        type: PORTAL_LOCATION_LIST,
        data: tempObj
      });
    }

  } catch (e) {
  }
}

export const getSupplyWithLocation = (locationList) => async (dispatch) => {
  try {

    let dateList = []
    for (let i = 0; i <= 6; i++) {
      dateList.push(moment().subtract(i, 'months').format('M_YYYY'))
    }

    let promises = [];
    _.each(locationList , (location) => {
      _.each(dateList , (i) => {
        const promise = new Promise(async (resolve, reject) => { 
          let data = await post("/jobs/query/location_analytics", {
            location: location.charAt(0).toUpperCase() + location.slice(1).split(",")[0] + "_" + i              
          });
          resolve(data);
        });
        promises.push(promise);
      });
    });

  Promise.all(promises).then((values) => {
    let monthObject = {}
    for (const { jobs } of values){
      if (jobs.length !== 1){
        continue
      }
      else{
        const monthData = jobs[0]
        const monthNumber = monthData.location.split("_")[1]
        if (!monthObject[monthNumber]){
          monthObject[monthNumber] = {"total": 0}
        }

        for (const [key, value] of Object.entries(monthData.location_data)){
          if(!key.includes("percentage") && key !== "total"){
            let clean_string = key.charAt(0).toUpperCase() + key.slice(1).replaceAll("_", " ")
            if (!monthObject[monthNumber][clean_string]){
              monthObject[monthNumber][clean_string] = {name:clean_string, number_jobs:value}
            }
            else{
              monthObject[monthNumber][clean_string].number_jobs = value + monthObject[monthNumber][clean_string].number_jobs
            }
            monthObject[monthNumber]["total"] = value + monthObject[monthNumber]["total"]

          }
        }   
      }
    }
    const calculatedMonths = Object.keys(monthObject).map((monthNum) => {
      return {
        id : "aggregated_month_" + monthNum,
        month_digit: monthNum,
        occupation_details: Object.keys(monthObject[monthNum]).map((key) => {
          if (key !== "total"){
            return {
              ...monthObject[monthNum][key],
              percentage_in_total: Math.round((monthObject[monthNum][key].number_jobs / monthObject[monthNum]["total"] * 100) * 100 + Number.EPSILON ) / 100
            }
          }
        }).filter(Boolean)
      }
    })
    dispatch({
      type: PORTAL_SUPPLY_DATA,
      data: {jobs : calculatedMonths}
    });
  });


} catch (e) {
  console.log(e)
  }
}


export const getSupplyLowLevel = () => async dispatch => {
  try {
    const data = await post('/jobs/query/dashboard_jobs_analytics', {
      "target": "low level"
    });
    dispatch({
      type: PORTAL_SUPPLY_LOW,
      data: data
    });
  } catch (e) {

  }
}

export const getAdzunaCategory = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: PORTAL_ADZUNA_CATEGORY,
      data: [{"label": "Accounting & Finance Jobs", "tag": "accounting-finance-jobs"}, {"label": "IT Jobs", "tag": "it-jobs"}, {"label": "Sales Jobs", "tag": "sales-jobs"}, {"label": "Customer Services Jobs", "tag": "customer-services-jobs"}, {"label": "Engineering Jobs", "tag": "engineering-jobs"}, {"label": "HR & Recruitment Jobs", "tag": "hr-jobs"}, {"label": "Healthcare & Nursing Jobs", "tag": "healthcare-nursing-jobs"}, {"label": "Hospitality & Catering Jobs", "tag": "hospitality-catering-jobs"}, {"label": "PR, Advertising & Marketing Jobs", "tag": "pr-advertising-marketing-jobs"}, {"label": "Logistics & Warehouse Jobs", "tag": "logistics-warehouse-jobs"}, {"label": "Teaching Jobs", "tag": "teaching-jobs"}, {"label": "Trade & Construction Jobs", "tag": "trade-construction-jobs"}, {"label": "Admin Jobs", "tag": "admin-jobs"}, {"label": "Legal Jobs", "tag": "legal-jobs"}, {"label": "Creative & Design Jobs", "tag": "creative-design-jobs"}, {"label": "Graduate Jobs", "tag": "graduate-jobs"}, {"label": "Retail Jobs", "tag": "retail-jobs"}, {"label": "Consultancy Jobs", "tag": "consultancy-jobs"}, {"label": "Manufacturing Jobs", "tag": "manufacturing-jobs"}, {"label": "Scientific & QA Jobs", "tag": "scientific-qa-jobs"}, {"label": "Social work Jobs", "tag": "social-work-jobs"}, {"label": "Travel Jobs", "tag": "travel-jobs"}, {"label": "Energy, Oil & Gas Jobs", "tag": "energy-oil-gas-jobs"}, {"label": "Property Jobs", "tag": "property-jobs"}, {"label": "Charity & Voluntary Jobs", "tag": "charity-voluntary-jobs"}, {"label": "Domestic help & Cleaning Jobs", "tag": "domestic-help-cleaning-jobs"}, {"label": "Maintenance Jobs", "tag": "maintenance-jobs"}, {"label": "Part time Jobs", "tag": "part-time-jobs"}, {"label": "Other/General Jobs", "tag": "other-general-jobs"}, {"label": "Unknown", "tag": "unknown"}]
    });

  } catch (e) {
  }
}

export const getAdzunaRegionData= (category, location) => async (dispatch, getState) => {
  try {
    const state = getState();
    const retries = 5;
    let data;

    for (var i = 1; i < retries; i++){
      data = await post('/jobs/query/get_adzuna_regional_data', {
        "category": category ? category : "", "location": location ? location : ""
      });
      if (data && !Array.isArray(data.jobs)){
        break
      }
      const delay = ms => new Promise(res => setTimeout(res, ms));
      await delay(1000)
    }
    dispatch({
      type: PORTAL_ADZUNA_REGION_DATA,
      data: data
    });

  } catch (e) {
  }
}

export const getAdzunaHistoricalCategory = (category, location) => async (dispatch, getState) => {
  try {
    const state = getState();
    const retries = 5;
    let data;

    for (var i = 1; i < retries; i++){
      data = await post('/jobs/query/get_adzuna_historical_category', {
        "category": category ? category : "", "location": location ? location : ""
      });
      if (data && !Array.isArray(data.jobs)){
        break
      }
      const delay = ms => new Promise(res => setTimeout(res, ms));
      await delay(1000)
    }

    dispatch({
      type: PORTAL_ADZUNA_HISTORICAL_CATEGORY,
      data: data
    });

  } catch (e) {
  }
}

export const getAdzunaHistogramCategory = (category, location) => async (dispatch, getState) => {
  try {
    const state = getState();
    const retries = 5;
    let data;

    for (var i = 1; i < retries; i++){
      data = await post('/jobs/query/get_adzuna_histogram_category', {
        "category": category ? category : "", "location": location ? location : ""
      });
      if (data && !Array.isArray(data.jobs)){
        break
      }
      const delay = ms => new Promise(res => setTimeout(res, ms));
      await delay(1000)
    }

    dispatch({
      type: PORTAL_ADZUNA_HISTOGRAM_CATEGORY,
      data: data
    });

  } catch (e) {
  }
}




export const getOrgAdminCaseload = () => async dispatch => {
  try {
    const { data: orgadminCaseload } = await get(`/orgadmin/caseload`);
    dispatch({
      type: PORTAL_ORGADMIN_CASELOAD,
      caseload: orgadminCaseload
    });
    dispatch({
      type: PORTAL_DASHBOARD_CASELOAD,
      caseload: _.cloneDeep(orgadminCaseload)
    });
  } catch (e) {
    logger.error("getOrgAdminCaseload():", e);
  }
};

export const setOrgContract = (contractID, selectedProvider) => async (dispatch, getState) => {
  let {portaldetails} = getState();
  let newPortaldetails = _.cloneDeep(portaldetails);

  let caseloadObj;
  if (selectedProvider === "all") {
    if (contractID === "all") {
      caseloadObj = newPortaldetails.caseload.orgadminCaseload;
    } else {
      caseloadObj = newPortaldetails.caseload.orgadminCaseload
        .contracts[contractID];
    }
  } else {
    if (contractID === "all" && selectedProvider.length === 1) {
      if (selectedProvider[0]){
        caseloadObj = newPortaldetails.caseload.orgadminCaseload
        .providers[selectedProvider[0].value];
      } else {
        caseloadObj = newPortaldetails.caseload.orgadminCaseload
      }
    } else {
      let lastObjectMerged = false;
      for (let i = 0; i < selectedProvider.length - 1; i++){
        // this check will see if contracts exists in both parent and child before trying to merge them.
        // all contracts doesn't exist in contracts but in it own object all so it needs seperated with an else

          let provider1 = newPortaldetails.caseload.orgadminCaseload
          .providers[selectedProvider[i].value].contracts[contractID];
          let provider2 = newPortaldetails.caseload.orgadminCaseload
          .providers[selectedProvider[i + 1].value].contracts[contractID];
          
          if (contractID === "all"){
            provider1 = newPortaldetails.caseload.orgadminCaseload
            .providers[selectedProvider[i].value];
            provider2 = newPortaldetails.caseload.orgadminCaseload
            .providers[selectedProvider[i + 1].value];  
          }

          let providerMerge1 = {};
          let providerMerge  = {};

          if (provider1){
            providerMerge  = JSON.stringify(provider1);
            providerMerge  = JSON.parse(providerMerge); 
          }
          if (provider2){
            providerMerge1 = JSON.stringify(provider2);
            providerMerge1 = JSON.parse(providerMerge1);
          }
          
          if (lastObjectMerged){
            lastObjectMerged = mergeObjectsWithSum(lastObjectMerged, providerMerge1);
          } else {
            lastObjectMerged = mergeObjectsWithSum(providerMerge, providerMerge1);
          }
      }
      // double check there isn't a single instance of data rather than a merge.

      if (contractID !== "all" && lastObjectMerged.contracts){
        caseloadObj = lastObjectMerged.contracts[contractID];
      } else if (contractID !== "all" && !lastObjectMerged){
        caseloadObj = newPortaldetails.caseload.orgadminCaseload
        .providers[selectedProvider[0].value].contracts[contractID];
      }  else {
        caseloadObj = lastObjectMerged
      }

      dispatch({
        type: PORTAL_DASHBOARD_CASELOAD,
        caseload: caseloadObj,
      });

    }
  }
}


export const setProviderChange = (providerID, setState) => async (dispatch, getState) => {
  let state = getState();
  
  let newLocalState = {
    selectedProvider: (providerID) ? providerID : "all",
    selectedContract: "all",
    contracts: false
  };
  let lastObjectMerged = false;
  let caseloadObj; let providerIds = []; let containsAll = true;
  // return false;

  if (providerID && Array.isArray(providerID) && providerID.length > 0){
    containsAll = false;
    providerID.forEach((provider) => {
      if (provider.value){
        providerIds.push(provider.value);
      }
    });

  }

  if (containsAll) {
    caseloadObj = state.portaldetails.caseload.orgadminCaseload;
  } else {

    let caseloadObjs = [];
    if (providerIds.length > 0){
      providerIds.forEach((provider) => {
        // Use cloneDeep to prevent state mutation errors in the reducer.
        caseloadObj = _.cloneDeep(state.portaldetails.caseload.orgadminCaseload.providers[provider]);
        caseloadObjs.push(caseloadObj);
      });
    }

    if (caseloadObjs.length > 1){
      for (var i = 0; i < (caseloadObjs.length - 1); i++){
         // stop deep cloning by creating a string and converting it to an object.
        if (lastObjectMerged){
          lastObjectMerged = mergeObjectsWithSum(lastObjectMerged, _.cloneDeep(caseloadObjs[i + 1]));
        } else {
          lastObjectMerged = mergeObjectsWithSum(caseloadObjs[i], caseloadObjs[i + 1]);
        }
      }
    }

    let providersContactsMerge;
    if (providerIds.length > 1){
      for (let x = 0; x < (providerIds.length - 1); x++){
         // stop deep cloning
        if (providersContactsMerge){

          let provider1 = state.portaldetails.caseload.orgadminCaseload.providers[
            providerIds[x + 1]
          ].contracts;
          
          providersContactsMerge = mergeObjectsWithSum(providersContactsMerge, _.cloneDeep(provider1));

        } else {
          let provider  = state.portaldetails.caseload.orgadminCaseload.providers[
            providerIds[x]
          ].contracts;
          let provider1 = state.portaldetails.caseload.orgadminCaseload.providers[
            providerIds[x + 1]
          ].contracts;
          providersContactsMerge = mergeObjectsWithSum(_.cloneDeep(provider), _.cloneDeep(provider1));
        }

        newLocalState.contracts =providersContactsMerge

      }
    } else {
        newLocalState.contracts = state.portaldetails.caseload.orgadminCaseload.providers[providerIds[0]].contracts}
  }

  setState(newLocalState);


  dispatch({
    type: PORTAL_DASHBOARD_CASELOAD,
    caseload: (lastObjectMerged) ? lastObjectMerged : caseloadObj,
  });

}

export const trackBulkUpload = (bulkJobID, userID, emailContent, inputData) => async (dispatch, getState) => {
  dispatch({type: UPDATE_BULK_UPLOAD_PROGRESS, data: false});
  if(inputData){
    try {
      await uploadData({
        path: ({ identityId }) => `${userID}/${bulkJobID}/bulkUpload.json`,
        data: JSON.stringify({
          data: inputData,
          emailContent: emailContent,
        }),
      });
  
    } catch (e) {
      console.log(e);
      alert(e.message);
      return false
    }
  }

  try{
    let initialWait = true
    let jobRunning = 0;
    const maxRuns = 999;
    const waitTime = 3000;
    const delay = ms => new Promise(res => setTimeout(res, ms));
    let data = false;
    do {
      jobRunning += 1
      await delay(waitTime)
      data = await post(`/orgadmin/bulkupload/track`, {
        bulkJobID: bulkJobID
      });
      if (data){
        if(data.progress){
          dispatch({type: UPDATE_BULK_UPLOAD_PROGRESS, data: data.progress});
        }
        if(inputData){
          if (data.stage === 1 && !data.running){
            jobRunning = maxRuns
          }
        }
        else{
          if (!data.running){
            jobRunning = maxRuns
          }
        }
      }
      else{
        if (initialWait){
          initialWait = false
        }
        else{
          jobRunning = maxRuns
        }
      }
    } while (jobRunning < maxRuns);


    if(!data.error){
      const getUrlResult = await getUrl({
        path: ({identityId}) => "private/"+ userID +"/"+ bulkJobID + "/response.json",
      });
      const responseUrl = getUrlResult.url.href;
      data.data = await (await fetch(responseUrl)).json();
    }
    return data
    } catch (e) {
      logger.error("error():", e);
    }
}

export const getBulkEmailTemplate = () => async (dispatch, getState) => {
  const data = await post(`/orgadmin/bulkupload/template/get`, {});
  if (data && data.data){
    dispatch({
      type: SET_BULK_EMAIL_TEMPLATE,
      data: data.data,
    });
    return data.data
  }
}

export const setBulkEmailTemplate = (newtemplate) => async (dispatch, getState) => {
  const data = await post(`/orgadmin/bulkupload/template/set`, {
    data: newtemplate
  });
  dispatch({
    type: SET_BULK_EMAIL_TEMPLATE,
    data: newtemplate,
  });
}

export const fetchRoles = () => async (dispatch, getState) => {
  const {portaldetails:{selectedProvider}} = getState();
  const data = await post(`/internal-mobility/roles/get`, 
    {provider: selectedProvider ? selectedProvider.sort : false});
  if(data && data.success){
    dispatch({type: SET_ROLES, data: data.data, unverifiedRoles: data.unverifiedRoles});
    dispatch({ type: FETCH_SKILL_TYPES, data: data && data.skillTypeMap ? data.skillTypeMap : {} });
  }
}

export const fetchInternalSkills = () => async (dispatch, getState) => {
  const {portaldetails:{selectedProvider}} = getState();
  const data = await post(`/internal-mobility/skills/get`, 
    {provider: selectedProvider ? selectedProvider.sort : false});
  if(data && data.success){
    dispatch({type: SET_SKILLS, data: data.activeSkills, removed: data.removedSkills});
  }
}

export const addRole = (newRole, editRole) => async (dispatch, getState) => {
  let {
    portaldetails:{
      internalRoles= [],
      unverifiedRoles= []
    }
  } = getState();
  const data = await post(`/internal-mobility/roles`, newRole);
  if (data && data.success) {
    const newRoles = editRole
      ? internalRoles.map(role => (role.ID === newRole.ID ? newRole : role))
      : [...internalRoles, data.data];
    
    dispatch({type: SET_ROLES, data: newRoles, unverifiedRoles: unverifiedRoles});
  }
}


export const removeRole = (roleID, newValue) => async (dispatch) => {
  const remove = await post(`/internal-mobility/roles/remove`, {
    roleID: roleID,
    newValue: newValue  });
  if(remove && remove.success){
    dispatch(fetchRoles())
  }
}

export const fetchDepartments = () => async (dispatch, getState) => {
  const {portaldetails:{selectedProvider}} = getState();
  const data = await post(`/internal-mobility/departments/get`, 
    {provider: selectedProvider ? selectedProvider.sort : false});
  if(data && data.success){
    dispatch({type: SET_DEPARTMENTS, data: data.data, unverifiedDepartments: data.unverifiedDepartments});
  }
}

export const addDepartment = (newDepartment) => async (dispatch, getState) => {
  let {
    portaldetails:{
      internalDepartments= [],
      unverifiedDepartments= []
    }
  } = getState();
  const data = await post(`/internal-mobility/departments`, newDepartment);
  if(data && data.success){
    dispatch({type: SET_DEPARTMENTS, data: [...internalDepartments, data.data], unverifiedDepartments: unverifiedDepartments});
  }
}

export const removeDepartment = (departmentID, newValue) => async (dispatch) => {
  const remove = await post(`/internal-mobility/departments/remove`, {
    departmentID: departmentID,
    newValue: newValue  });
  if(remove && remove.success){
    dispatch(fetchDepartments())
  }
}


export const fetchLocations = () => async (dispatch, getState) => {
  const {portaldetails:{selectedProvider}} = getState();
  const data = await post(`/internal-mobility/locations/get`, 
    {provider: selectedProvider ? selectedProvider.sort : false});
  if(data && data.success){
    dispatch({type: SET_LOCATIONS, data: data.data, unverifiedLocations: data.unverifiedLocations});
  }
}

export const addLocation = (newLocation) => async (dispatch, getState) => {
  let {
    portaldetails:{
      internalLocations= [],
      unverifiedLocations= []
    }
  } = getState();
  const data = await post(`/internal-mobility/locations`, newLocation);
  if(data && data.success){
    dispatch({type: SET_LOCATIONS, data: [...internalLocations, data.data], unverifiedLocations: unverifiedLocations});
  }
}


export const removeLocation = (locationID, newValue) => async (dispatch) => {
  const remove = await post(`/internal-mobility/locations/remove`, {
    locationID: locationID,
    newValue: newValue  });
  if(remove && remove.success){
    dispatch(fetchLocations())
  }
}

export const removeLineManagers = (lineManagerID, newValue) => async (dispatch) => {
  const remove = await post(`/internal-mobility/linemanagers/remove`, {
    lineManagerID: lineManagerID,
    newValue: newValue  });
  if(remove && remove.success){
    dispatch(fetchLineManagers())
  }
}

export const fetchLineManagers = () => async (dispatch, getState) => {
  const {portaldetails:{selectedProvider}} = getState();
  const data = await post(`/internal-mobility/linemanagers/get`, 
    {provider: selectedProvider ? selectedProvider.sort : false});
  if(data && data.success){
    dispatch({type: SET_LINEMANAGERS, data: data.data, unverifiedLineManagers: data.unverifiedLineManagers});
  }
}

export const fetchUnverifiedCounts = () => async (dispatch, getState) => {
  const data = await get(`/internal-mobility/unverified`, {});
  if(data && data.success){
    dispatch({type: SET_UNVERIFIED, data: data});
  }
}

export const fetchDemographics = () => async (dispatch, getState) => {
  const data = await get(`/internal-mobility/demographics`, {});
  if(data && data.success){
    dispatch({type: SET_DEMOGRAPHICS, data: data.data});
  }
}

export const updateDemographics = (newQuestions) => async (dispatch, getState) => {
  const data = await post(`/internal-mobility/demographics`, {
    questions: newQuestions  });
  if(data && data.success){
    dispatch({type: SET_DEMOGRAPHICS, data: data.data});
  }
}

export const updateUserRoleInternalMobility = (userID, roleID) => async (dispatch, getState) => {
  const data = await post(`/internal-mobility/user/setRole`, {
    userID: userID,
    roleID: roleID  });
  if(data && data.success){
    await dispatch(fetchRoles());
  }
}

export const addSkillToRole = (skill, roleID) => async (dispatch, getState) => {
  const {portaldetails:{internalRoles= []}} = getState();
  let newRole = internalRoles.find((item) => item.ID === roleID);
  if(newRole){
    newRole.skills = [...newRole.skills, {type: "essential", skill: skill.skill}]
    await dispatch(addRole(newRole, true));
    dispatch(fetchInternalSkills());
  }
}

export const addUnAssignedSkill = (skill) => async (dispatch, getState) => {
  console.log("addUnAssignedSkill")
  console.log(skill)
  try{
    if(skill){
      await post(`/internal-mobility/skills/add`, {
        skill: skill      });
      dispatch(fetchInternalSkills());
    }
  }
  catch{
    return
  }
}

export const removeActiveSkill = (skill) => async (dispatch, getState) => {
  const {portaldetails:{internalRoles= []}} = getState();
  try{
    if(skill){
      await post(`/internal-mobility/skills/remove`, {
        skill: skill      });
      const addRolePromises = [];
      for(const role of internalRoles){
        if(role.skills.find((item) => item.skill === skill)){
          addRolePromises.push(dispatch(addRole({
            ...role,
            skills: role.skills.filter((item) => item.skill !== skill)
          }, true)));
        }
      }

      await Promise.all(addRolePromises);
      dispatch(fetchInternalSkills());
    }
  }
  catch{
    return
  }
}

export const updateUserDepartmentsInternalMobility = (userID, departmentID) => async (dispatch, getState) => {
  const data = await post(`/internal-mobility/user/setDepartment`, {
    userID: userID,
    departmentID: departmentID  });
  if(data && data.success){
    await dispatch(fetchDepartments());
  }
}

export const updateUserLineManagerInternalMobility = (userID, lineManagerID) => async (dispatch, getState) => {
  const data = await post(`/internal-mobility/user/setLineManager`, {
    userID: userID,
    lineManagerID: lineManagerID  });
  if(data && data.success){
    await dispatch(fetchLineManagers());
  }
}

export const getOccDetails = (text) => async (dispatch, getState) => {
  let response = await post("/data/occupation", {
    label: text  });
  if(response && response.data){
    if(response.data.essentialSkills){
      dispatch(fetchSkillTypes([...response.data.essentialSkills, ...response.data.optionalSkills]))
    }
    return response.data
  }
}


const unAuthenticatedVideos = {
  "UnAuth": {
      "paths": ["/login", "/forgot"],
      "videos": [
          {
              "id": "1HhF5mqS2r4tEACbbx5297",
              "title": "Login"
          },
          {
              "id": "kW2XiBYZpEaDWZs2EG9sx4",
              "title": "Forgot Password"
          }
      ]
  }
}

export const getHelpVideos = (path) => async (dispatch, getState) => {
  const {
      auth:{authenticated = false, role= ""}, 
      portaldetails: {authenticatedVideos}
  } = getState();
  try{
    if(authenticated){
      let videos = authenticatedVideos ? authenticatedVideos : []
      if(!authenticatedVideos){
          const data = await get(`/user/helpvideo`);
          if(data.success){
              videos = data.data
              dispatch({type: SET_HELP_VIDEOS, data: data.data});
          }
      }
      const pathData = Object.values(videos).find((value) => value.paths.includes(path))
      if(pathData){
          return {...pathData, videos: pathData.videos.filter((item) => !item.roles || (item.roles.includes(role)))}                
      }
    }
    else{
        return Object.values(unAuthenticatedVideos).find((value) => value.paths.includes(path))
    } 
  }
  catch{
    return
  }  
}

export function getSkillsChart(filters) {
  return async function(dispatch, getState) {
    dispatch({ type: SKILLS_CHART_DATA, data: false });
    const {portaldetails:{selectedProvider}} = getState();
    let queryFilters = _.cloneDeep({...filters, provider: selectedProvider ? selectedProvider.sort : false})
    if(filters.type === "internalMobility"){
      const { portaldetails: { internalRoles= [], internalLineManagers = [], internalDepartments = [], internalLocations = []}} = getState();
      queryFilters.roles = queryFilters.roles.map((item) => {
        const imRole = internalRoles.find((_item) => item === _item.roleName);
        return imRole ? imRole.ID : false
      }).filter(Boolean);
      queryFilters.lineManagers = queryFilters.lineManagers.map((item) => {
        const imLineManager = internalLineManagers.find((_item) => item === _item.nameEmail);
        return imLineManager ? imLineManager.userID : false
      }).filter(Boolean);
      queryFilters.locations = queryFilters.locations.map((item) => {
        const imLocation = internalLocations.find((_item) => item === _item.locationName);
        return imLocation ? imLocation.ID : false
      }).filter(Boolean);
      queryFilters.departments = queryFilters.departments.map((item) => {
        const imDepartment = internalDepartments.find((_item) => item === _item.departmentName);
        return imDepartment ? imDepartment.ID : false
      }).filter(Boolean);
    }

    try {
      let data = await post("/data/workforce-planning/getskillschart", 
        {filters:queryFilters});
      if(data && data.success){
        dispatch({ type: SKILLS_CHART_DATA, data: data.data });
      }
      else{
        dispatch({ type: SKILLS_CHART_DATA, data: [] });
      }

    } catch (e) {
      logger.error("getSkillsChart():", e);
      dispatch({ type: SKILLS_CHART_DATA, data: [] });
    }
  };
}

export function getRolesChart(filters) {
  return async function(dispatch, getState) {
    dispatch({ type: ROLES_CHART_DATA, data: false });
    const {portaldetails:{selectedProvider}} = getState();
    let queryFilters = _.cloneDeep({...filters, provider: selectedProvider ? selectedProvider.sort : false})
    if(filters.type === "internalMobility"){
      const { portaldetails: { internalRoles= [], internalLineManagers = [], internalDepartments = [], internalLocations = []}} = getState();
      queryFilters.roles = queryFilters.roles.map((item) => {
        const imRole = internalRoles.find((_item) => item === _item.roleName);
        return imRole ? imRole.ID : false
      }).filter(Boolean);
      queryFilters.lineManagers = queryFilters.lineManagers.map((item) => {
        const imLineManager = internalLineManagers.find((_item) => item === _item.nameEmail);
        return imLineManager ? imLineManager.userID : false
      }).filter(Boolean);
      queryFilters.locations = queryFilters.locations.map((item) => {
        const imLocation = internalLocations.find((_item) => item === _item.locationName);
        return imLocation ? imLocation.ID : false
      }).filter(Boolean);
      queryFilters.departments = queryFilters.departments.map((item) => {
        const imDepartment = internalDepartments.find((_item) => item === _item.departmentName);
        return imDepartment ? imDepartment.ID : false
      }).filter(Boolean);
    }

    try {
      let data = await post("/data/workforce-planning/getrolechart", 
        {filters:queryFilters});
      if(data && data.success){
        dispatch({ type: ROLES_CHART_DATA, data: data.data });
      }
      else{
        dispatch({ type: ROLES_CHART_DATA, data: [] });
      }

    } catch (e) {
      logger.error("getRolesChart():", e);
      dispatch({ type: ROLES_CHART_DATA, data: [] });
    }
  };
}

export function getPeopleChart(filters) {
  return async function(dispatch, getState) {
    dispatch({ type: PEOPLE_CHART_DATA, data: false });
    const {portaldetails:{selectedProvider}} = getState();
    let queryFilters = _.cloneDeep({...filters, provider: selectedProvider ? selectedProvider.sort : false})
    if(filters.type === "internalMobility"){
      const { portaldetails: { internalRoles= [], internalLineManagers = [], internalDepartments = [], internalLocations = []}} = getState();
      queryFilters.roles = queryFilters.roles.map((item) => {
        const imRole = internalRoles.find((_item) => item === _item.roleName);
        return imRole ? imRole.ID : false
      }).filter(Boolean);
      queryFilters.lineManagers = queryFilters.lineManagers.map((item) => {
        const imLineManager = internalLineManagers.find((_item) => item === _item.nameEmail);
        return imLineManager ? imLineManager.userID : false
      }).filter(Boolean);
      queryFilters.locations = queryFilters.locations.map((item) => {
        const imLocation = internalLocations.find((_item) => item === _item.locationName);
        return imLocation ? imLocation.ID : false
      }).filter(Boolean);
      queryFilters.departments = queryFilters.departments.map((item) => {
        const imDepartment = internalDepartments.find((_item) => item === _item.departmentName);
        return imDepartment ? imDepartment.ID : false
      }).filter(Boolean);
    }

    try {
      let data = await post("/data/workforce-planning/getpeoplechart", 
        {filters:queryFilters});
      if(data && data.success){
        dispatch({ type: PEOPLE_CHART_DATA, data: data.data });
      }
      else{
        dispatch({ type: PEOPLE_CHART_DATA, data: [] });
      }

    } catch (e) {
      logger.error("getPeopleChart():", e);
      dispatch({ type: PEOPLE_CHART_DATA, data: [] });
    }
  };
}

export function getProjectChart(filters) {
  return async function(dispatch, getState) {
    dispatch({ type: PROJECT_CHART_DATA, data: false });
    const {portaldetails:{selectedProvider}} = getState();
    let queryFilters = _.cloneDeep({...filters, provider: selectedProvider ? selectedProvider.sort : false})
    if(filters.type === "internalMobility"){
      const { portaldetails: { internalRoles= [], internalLineManagers = [], internalDepartments = [], internalLocations = []}} = getState();
      queryFilters.roles = queryFilters.roles.map((item) => {
        const imRole = internalRoles.find((_item) => item === _item.roleName);
        return imRole ? imRole.ID : false
      }).filter(Boolean);
      queryFilters.lineManagers = queryFilters.lineManagers.map((item) => {
        const imLineManager = internalLineManagers.find((_item) => item === _item.nameEmail);
        return imLineManager ? imLineManager.userID : false
      }).filter(Boolean);
      queryFilters.locations = queryFilters.locations.map((item) => {
        const imLocation = internalLocations.find((_item) => item === _item.locationName);
        return imLocation ? imLocation.ID : false
      }).filter(Boolean);
      queryFilters.departments = queryFilters.departments.map((item) => {
        const imDepartment = internalDepartments.find((_item) => item === _item.departmentName);
        return imDepartment ? imDepartment.ID : false
      }).filter(Boolean);
    }

    try {
      let data = await post("/data/workforce-planning/getprojectchart", 
        {filters:queryFilters});
      if(data && data.success){
        dispatch({ type: PROJECT_CHART_DATA, data: data.data });
      }
      else{
        dispatch({ type: PROJECT_CHART_DATA, data: [] });
      }

    } catch (e) {
      logger.error("getProjectChart():", e);
      dispatch({ type: PROJECT_CHART_DATA, data: [] });
    }
  };
}

export function fetchSimpleDetails(skillData, filters) {
  return async function(dispatch, getState) {
    logger.info("fetchSimpleDetails(): ");
    const state = getState();
    const isInternal = (state.auth.role === "hr-manager" || state.auth.role === "line-manager") ? true : false
    if(skillData){
      try {
        let data = await post("/data/workforce-planning/skillflyout", {
          selectedSkill:skillData.label,
          users:skillData.users,
          isInternal: isInternal,
          skillTypes: filters.skillTypes        });
        if(data && data.success){
          dispatch({ type: SET_FLYOUT_LIST, users: data.data, skills: [] });
        }
        else{
          dispatch({ type: SET_FLYOUT_LIST, users: [], skills: []});
        }
  
      } catch (e) {
        logger.error("fetchSimpleDetails():", e);
        dispatch({ type: SET_FLYOUT_LIST, users: [], skills: []});
      }
    }
    else{
      dispatch({ type: SET_FLYOUT_LIST, users: false, skills: false });
    }
  }
}

export function fetchRoleFlyout(selectedRole, filters) {
  return async function(dispatch, getState) {
    logger.info("fetchRoleFlyout(): ");
    const {portaldetails:{selectedProvider}} = getState();
    if(selectedRole){
      try {
        let data = await post("/data/workforce-planning/roleflyout", {
          roleID:selectedRole.roleID,
          users:selectedRole.users,
          provider: selectedProvider ? selectedProvider.sort : false,
          skillTypes: filters.skillTypes
        });
        if(data && data.success){
          dispatch({ type: SET_FLYOUT_LIST, users: data.data.users, skills: data.data.skills });
        }
        else{
          dispatch({ type: SET_FLYOUT_LIST, users: [], skills: []});
        }
  
      } catch (e) {
        logger.error("fetchRoleFlyout():", e);
        dispatch({ type: SET_FLYOUT_LIST, users: [], skills: []});
      }
    }
    else{
      dispatch({ type: SET_FLYOUT_LIST, users: false, skills: false });
    }
  }
}

export function fetchPersonFlyout(selectedUser, filters) {
  return async function(dispatch, getState) {
    logger.info("fetchPersonFlyout(): ");
    const {portaldetails:{selectedProvider}} = getState();
    if(selectedUser){
      try {
        let data = await post("/data/workforce-planning/personflyout", {
          userID:selectedUser.userID,
          provider: selectedProvider ? selectedProvider.sort : false,
          skillTypes: filters.skillTypes
        });
        if(data && data.success){
          dispatch({ type: SET_FLYOUT_LIST, users: data.data.users, skills: data.data.skills });
        }
        else{
          dispatch({ type: SET_FLYOUT_LIST, users: [], skills: []});
        }
  
      } catch (e) {
        logger.error("fetchPersonFlyout():", e);
        dispatch({ type: SET_FLYOUT_LIST, users: [], skills: []});
      }
    }
    else{
      dispatch({ type: SET_FLYOUT_LIST, users: false, skills: false });
    }
  }
}

export function fetchProjectFlyout(selectedProject, filters) {
  return async function(dispatch, getState) {
    logger.info("fetchPersonFlyout(): ");
    const {portaldetails:{selectedProvider}} = getState();
    if(selectedProject){
      try {
        let data = await post("/data/workforce-planning/projectflyout", {
          users:selectedProject.users,
          skills:selectedProject.skills,
          provider: selectedProvider ? selectedProvider.sort : false,
          skillTypes: filters.skillTypes
        });
        if(data && data.success){
          dispatch({ type: SET_FLYOUT_LIST, users: data.data.users, skills: data.data.skills });
        }
        else{
          dispatch({ type: SET_FLYOUT_LIST, users: [], skills: []});
        }
  
      } catch (e) {
        logger.error("fetchProjectFlyout():", e);
        dispatch({ type: SET_FLYOUT_LIST, users: [], skills: []});
      }
    }
    else{
      dispatch({ type: SET_FLYOUT_LIST, users: false, skills: false });
    }
  }
}

export function fetchCandidateDetals(candidate) {
  return async function(dispatch, getState) {
    logger.info("fetchCandidateDetals(): ");
    if(candidate){
      try {
        const data = await post("/employer/job/user/details", {
          candidateID: candidate.userID,
          skills: []        });
        if(data){
          dispatch({ type: SET_FLYOUT_CANDIDATE, data: {...data, profileUrl: candidate.profileUrl}});
          if(data && data.occupationSkills && data.occupationSkills.length){
            dispatch(fetchSkillTypes(data.occupationSkills.flatMap(occ => occ.skills.map(skill => (skill.name)))))
          }
        }
        else{
          dispatch({ type: SET_FLYOUT_CANDIDATE, data: false });
        }
      } catch (e) {
        logger.error("fetchSimpleDetails():", e);
        dispatch({ type: SET_FLYOUT_CANDIDATE, data: false });
      }
    }
    else{
      dispatch({ type: SET_FLYOUT_CANDIDATE, data: false });
    }
  }
}

export function fetchSkillTypes(skills = []) {
  return async function(dispatch, getState) {
    logger.info("fetchSkillTypes(): ");
    try {
      if(skills && skills.length){
        const data = await post("/data/skills/types", {
          skills: skills        });
        if(data){
          dispatch({ type: FETCH_SKILL_TYPES, data: data && data.data ? data.data : {} });
        }
        else{
          dispatch({ type: FETCH_SKILL_TYPES, data: {} });
        }
      }
    } catch (e) {
      logger.error("fetchSkillTypes():", e);
      dispatch({ type: FETCH_SKILL_TYPES, data: {} });
    }
  }
}

export function fetchRecommnededTooling(occupation) {
  return async function(dispatch, getState) {
    logger.info("fetchRecommnededTooling(): ");
    try {
      const data = await post("/jobs/query/automation_tools", {
        occupation: "bid writer"      });
    } catch (e) {
      logger.error("fetchRecommnededTooling():", e);
    }
  }
}